<template>

  <div v-if="prescDrugs.length" class="drug-list">
    <template v-for="grupo in gruposDeDocumento" :key="grupo.key">
    <div v-if="mostrarGrupos" class="drug-group-head">
      <span class="drug-group-title">{{ grupo.title }}</span>
      <span class="drug-group-count">{{ grupo.drugs.length === 1 ? '1 item' : grupo.drugs.length + ' itens' }}</span>
    </div>
    <div v-for="prescDrug in grupo.drugs" :key="prescDrug.id_presc_drug" class="drug-item-block">
      <div class="drug-item">
        <span class="drug-item-index">{{ grupo.drugs.indexOf(prescDrug) + 1 }}</span>
        <div class="drug-item-body">
          <div class="drug-item-top">
            <div class="drug-item-identity">
              <span class="drug-item-name">{{ prescDrug.drug_name }}</span>
              <span v-if="prescDrug.item_kind === 'compounded'" class="drug-item-presentation">Fórmula</span>
              <span v-if="presentationSummary(prescDrug)" class="drug-item-presentation">
                {{ presentationSummary(prescDrug) }}
              </span>
              <RegulatoryBadge :classification="classificationFor(prescDrug)"/>
              <button v-if="podeTrocarTipo(prescDrug)" type="button" class="drug-item-change-type"
                      @click="abrirTrocaDeTipo(prescDrug)">
                alterar
              </button>
            </div>
            <div class="drug-item-aside">
              <span v-if="prescDrug.drug_administrations?.drug_admin_name" class="drug-item-route">
                {{ prescDrug.drug_administrations.drug_admin_name }}
              </span>
              <div v-if="!readonly && !prescription.presc_request_generated" class="drug-item-actions">
                <button type="button" class="btn btn-icon btn-sm btn-bg-light btn-active-color-primary"
                        data-bs-toggle="modal"
                        :data-bs-target="'#modal_edit_drug_' + prescription.id_presc"
                        @click="onClickBtnEditDrug(prescDrug)"
                        title="Editar">
                  <i class="bi bi-pencil-square"></i>
                </button>
                <button type="button" class="btn btn-icon btn-sm btn-bg-light btn-active-color-primary"
                        @click="deleteDrug(prescDrug.id_presc_drug)"
                        title="Excluir medicamento">
                  <i class="bi bi-trash"></i>
                </button>
              </div>
            </div>
          </div>
          <div v-if="prescDrug.dosage_desc" class="drug-item-dosage">{{ prescDrug.dosage_desc }}</div>
          <div v-if="prescDrug.drug_obs" class="drug-item-obs">{{ prescDrug.drug_obs }}</div>
        </div>
      </div>
      <div v-if="trocandoTipo === prescDrug.id_presc_drug" class="drug-item-change">
        <label :for="'troca_tipo_' + prescDrug.id_presc_drug" class="drug-item-change-label">
          Receituário deste medicamento
        </label>
        <div class="drug-item-change-actions">
          <select class="form-control form-select form-select-sm"
                  :id="'troca_tipo_' + prescDrug.id_presc_drug"
                  v-model="tipoEscolhido"
                  :disabled="savingRegulatoryType === prescDrug.id_presc_drug">
            <option value="" disabled>--Selecione o receituário--</option>
            <option :value="type.code" v-for="type in regulatoryTypes" :key="type.code">{{ type.name }}</option>
          </select>
          <button type="button" class="btn btn-sm btn-primary"
                  :disabled="!tipoEscolhido || savingRegulatoryType === prescDrug.id_presc_drug"
                  @click="confirmarTrocaDeTipo(prescDrug)">
            {{ savingRegulatoryType === prescDrug.id_presc_drug ? 'Salvando...' : 'Confirmar' }}
          </button>
          <button type="button" class="btn btn-sm btn-light" @click="trocandoTipo = null">Cancelar</button>
        </div>
        <p class="drug-item-change-note">
          A classificação da substância é o ponto de partida. Alterar o receituário é
          decisão sua, e fica registrada em seu nome.
        </p>
      </div>

      <div v-if="unresolvedFor(prescDrug)" class="drug-item-pending">
        <RegulatoryManualSelect :classification="unresolvedFor(prescDrug)"
                                :types="regulatoryTypes"
                                :readonly="readonly || prescription.presc_request_generated"
                                :saving="savingRegulatoryType === prescDrug.id_presc_drug"
                                @confirm="setRegulatoryType(prescDrug, $event)"/>
      </div>
    </div>
    </template>
  </div>

  <div v-if="showRegulatorySummary" class="regulatory-summary regulatory-summary-blocked">
    <span class="regulatory-summary-text">
      <i class="bi bi-exclamation-triangle-fill"></i>
      {{ regulatorySummaryText }}
    </span>
  </div>

  <button v-if="podeAdicionar && !formAberto" type="button" class="drug-add-trigger"
          @click="abrirFormulario">
    <i class="bi bi-plus-lg"></i>
    {{ formStoreDrug.item_kind === 'compounded' ? 'Adicionar fórmula' : 'Adicionar medicamento' }}
  </button>

  <div v-if="podeAdicionar && formAberto" class="drug-form drug-form-inline">
    <div class="drug-form-head">
      <p class="drug-form-title">{{ formStoreDrug.item_kind === 'compounded' ? 'Adicionar fórmula' : 'Adicionar medicamento' }}</p>
      <button type="button" class="drug-form-close" title="Fechar" @click="fecharFormulario">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>
    <form @submit.prevent="submitFormStoreDrug">
      <PrescriptionDrugFields :drug="formStoreDrug"
                              :drug-admins="drugAdmins"
                              :errors="formStoreDrugErrors"
                              :id-prefix="'store-drug-' + prescription.id_presc"
                              @catalog="applyCatalogDrug(formStoreDrug, $event)"
                              @clear-catalog="clearCatalogLink(formStoreDrug)"/>
      <div class="drug-form-actions">
        <button type="submit" class="btn btn-primary">Adicionar</button>
      </div>
    </form>
  </div>

  <Teleport to="body">
<div class="modal fade" tabindex="-1" :id="'modal_edit_drug_' + prescription.id_presc">
    <div class="modal-dialog modal-lg">
      <form method="post" @submit.prevent="submitFormEditDrug">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ formEditDrug.item_kind === 'compounded' ? 'Alterar fórmula' : 'Alterar medicamento' }}</h5>
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Fechar">
              <i class="bi bi-x-lg"></i>
            </div>
          </div>
          <div class="modal-body drug-form">
            <PrescriptionDrugFields :drug="formEditDrug"
                                    :drug-admins="drugAdmins"
                                    :errors="formEditDrugErrors"
                                    :id-prefix="'edit-drug-' + prescription.id_presc"
                                    @catalog="applyCatalogDrug(formEditDrug, $event)"
                                    @clear-catalog="clearCatalogLink(formEditDrug)"/>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-light" data-bs-dismiss="modal">Fechar</button>
            <button type="submit" class="btn btn-primary">Salvar</button>
          </div>
        </div>
      </form>
    </div>
  </div>
  </Teleport> <!-- modal_edit_drug -->

</template>

<script>
import http from "../../../helpers/http";
import Alert from "../../../helpers/alert";
import PrescriptionDrugFields from "../shared/PrescriptionDrugFields.vue";
import RegulatoryBadge from "../shared/RegulatoryBadge.vue";
import RegulatoryManualSelect from "../shared/RegulatoryManualSelect.vue";
import {classificationFromType} from "@/helpers/regulatoryTypes";

export default {
  name: "PrescriptionDrugs",
  emits: ['regulatory-changed'],
  components: { PrescriptionDrugFields, RegulatoryBadge, RegulatoryManualSelect },
  props: {
    medicalRecord: Object,
    prescription: Object,
    readonly: false,
    drugAdmins: Array,
    regulatoryPlan: Object,
    regulatoryTypes: {
      type: Array,
      default: () => [],
    },
    prescTypes: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      prescDrugs: [],
      savingRegulatoryType: null,
      trocandoTipo: null,
      tipoEscolhido: '',
      // Prescrição vazia abre com o formulário pronto; com itens na lista ele
      // começa fechado para não competir visualmente com o que já foi receitado.
      formAberto: false,
      formStoreDrug: {
        id_presc: '',
        id_drug_admin: '',
        drug_name: '',
        id_drug: null,
        concentration: '',
        pharmaceutical_form: '',
        quantity: '',
        continuous_use: false,
        monthly_quantity: '',
        dosage_desc: '',
        treatment_time: '',
        drug_obs: '',
      },
      formStoreDrugErrors: [],
      formEditDrug: {
        id_presc: '',
        item_kind: 'medication',
        id_drug_admin: '',
        drug_name: '',
        id_drug: null,
        concentration: '',
        pharmaceutical_form: '',
        quantity: '',
        measure: '',
        composition: '',
        regulatory_type: 'SIMPLES',
        continuous_use: false,
        monthly_quantity: '',
        dosage_desc: '',
        treatment_time: '',
        drug_obs: '',
      },
      formEditDrugErrors: [],
    }
  },
  mounted() {
    this.prescDrugs = [...(this.prescription.drugs ?? [])];
    this.formStoreDrug = this.emptyDrugForm();
    // Prescrição recém-criada não tem o que esconder: já abre pronta para digitar.
    this.formAberto = this.podeAdicionar && this.prescDrugs.length === 0;
  },
  watch: {
    'formEditDrug.continuous_use'(continuo) {
      if (continuo) {
        this.formEditDrug.treatment_time = '';
        return;
      }

      this.formEditDrug.monthly_quantity = '';
    },
    /**
     * A quebra por tipo acontece na emissão e MOVE itens para as prescrições
     * irmãs. A prescrição original mantém id_presc e payload, então a chave do
     * componente não muda e esta lista continuaria exibindo o medicamento que
     * já saiu daqui.
     */
    'prescription.presc_request_generated'(gerada, antes) {
      if (gerada && !antes) {
        this.getPrescDrugs();
      }
    },
  },
  computed: {
    podeAdicionar() {
      return !this.readonly && !this.prescription.presc_request_generated;
    },
    /**
     * Equivalente regulatorio do tipo que o medico escolheu na criacao. A
     * conversao vem da API: o front nao tem tabela de "especial vira RCE".
     */
    chosenRegulatoryType() {
      const escolhido = this.prescTypes.find(
          (tipo) => tipo.id_presc_type === this.prescription.id_presc_type);

      return escolhido?.regulatory_type
          ?? this.prescription.prescription_type?.regulatory_type
          ?? null;
    },
    chosenTypeName() {
      const escolhido = this.prescTypes.find(
          (tipo) => tipo.id_presc_type === this.prescription.id_presc_type);

      return escolhido?.presc_type_name
          ?? this.prescription.prescription_type?.presc_type_name
          ?? 'tipo escolhido';
    },
    classifications() {
      return this.regulatoryPlan?.items ?? [];
    },
    /**
     * A lista espelha os documentos que a emissão vai gerar. A quebra de fato
     * continua acontecendo na emissão: aqui nada é criado, só agrupado — a
     * prescrição é rascunho enquanto o médico edita.
     */
    gruposDeDocumento() {
      const documentos = this.regulatoryPlan?.documents ?? [];
      const porId = new Map(this.prescDrugs.map((item) => [item.id_presc_drug, item]));
      const grupos = [];
      const agrupados = new Set();

      documentos.forEach((documento) => {
        const drugs = (documento.items ?? [])
            .map((item) => porId.get(item.id_presc_drug))
            .filter(Boolean);

        if (!drugs.length) return;

        drugs.forEach((drug) => agrupados.add(drug.id_presc_drug));
        grupos.push({
          key: documento.regulatory_type,
          title: this.regulatoryName(documento.regulatory_type, documento.regulatory_type_description),
          drugs,
        });
      });

      // Pendente e bloqueado não entram em documento nenhum: ficam no fim,
      // onde o seletor manual já aparece.
      const restantes = this.prescDrugs.filter((item) => !agrupados.has(item.id_presc_drug));

      if (restantes.length) {
        grupos.push({key: '__sem_tipo', title: 'Sem receituário definido', drugs: restantes});
      }

      return grupos.length ? grupos : [{key: '__todos', title: '', drugs: this.prescDrugs}];
    },
    /**
     * Um documento só não precisa de cabeçalho: a separação só informa quando
     * existe mais de um.
     */
    mostrarGrupos() {
      return this.gruposDeDocumento.length > 1;
    },
    unresolvedCount() {
      const plan = this.regulatoryPlan;
      if (!plan) {
        return 0;
      }

      return (plan.pending?.length ?? 0) + (plan.blocked?.length ?? 0);
    },
    /** Só o que impede gerar: a contagem de documentos saiu da tela. */
    showRegulatorySummary() {
      return this.prescDrugs.length > 0
          && !this.prescription.presc_request_generated
          && this.regulatoryPlan != null
          && this.unresolvedCount > 0;
    },
    regulatorySummaryText() {
      return this.unresolvedCount === 1
          ? 'Há 1 medicamento sem receituário definido. A prescrição não será gerada enquanto isso não for resolvido.'
          : `Há ${this.unresolvedCount} medicamentos sem receituário definido. A prescrição não será gerada enquanto isso não for resolvido.`;
    },
  },
  methods: {
    classificationFor(prescDrug) {
      const classification = this.classifications.find((item) => item.id_presc_drug === prescDrug.id_presc_drug);
      if (classification) {
        return classification;
      }

      if (this.prescription.presc_request_generated && this.prescription.regulatory_type) {
        return classificationFromType(this.prescription.regulatory_type);
      }

      return null;
    },
    unresolvedFor(prescDrug) {
      const classification = this.classificationFor(prescDrug);
      if (!classification || classification.status === 'CLASSIFIED') {
        return null;
      }

      return classification;
    },
    /**
     * Item pendente já tem o seletor próprio; aqui é a troca de quem já está
     * classificado — inclusive de uma escolha manual anterior.
     */
    podeTrocarTipo(prescDrug) {
      if (this.readonly || this.prescription.presc_request_generated) return false;

      const classificacao = this.classificationFor(prescDrug);

      return classificacao?.status === 'CLASSIFIED'
          && this.trocandoTipo !== prescDrug.id_presc_drug;
    },
    abrirTrocaDeTipo(prescDrug) {
      this.trocandoTipo = prescDrug.id_presc_drug;
      this.tipoEscolhido = this.classificationFor(prescDrug)?.regulatory_type ?? '';
    },
    confirmarTrocaDeTipo(prescDrug) {
      const escolhido = this.tipoEscolhido;
      this.setRegulatoryType(prescDrug, escolhido, () => {
        this.trocandoTipo = null;
        this.tipoEscolhido = '';
      });
    },
    setRegulatoryType(prescDrug, regulatoryType, aoConcluir = null) {
      this.savingRegulatoryType = prescDrug.id_presc_drug;
      http.put(`/professionals/${this.medicalRecord.id_prof}/patients/${this.medicalRecord.id_patient}/medical-records/${this.prescription.id_medrec}/prescriptions/${this.prescription.id_presc}/drugs/${prescDrug.id_presc_drug}/regulatory-type`, {
        regulatory_type: regulatoryType,
      }).then(() => {
        this.getPrescDrugs();
        this.$emit('regulatory-changed');
        aoConcluir?.();
        Alert.toastSuccess("Receituário definido para o medicamento.");
      }).catch(e => {
        Alert.toastError(e.response?.data?.message ?? e.response?.data ?? 'Não foi possível definir o receituário.');
      }).finally(() => {
        this.savingRegulatoryType = null;
      });
    },
    emptyDrugForm() {
      const oral = this.drugAdmins?.find((admin) => /oral/i.test(admin.drug_admin_name ?? ''));
      return {
        id_presc: '',
        item_kind: 'medication',
        id_drug_admin: oral?.id_drug_admin ?? this.drugAdmins?.[0]?.id_drug_admin ?? '',
        drug_name: '',
        id_drug: null,
        concentration: '',
        pharmaceutical_form: '',
        quantity: '',
        measure: '',
        composition: '',
        regulatory_type: 'SIMPLES',
        continuous_use: false,
        monthly_quantity: '',
        dosage_desc: '',
        treatment_time: '',
        drug_obs: '',
        controlled: false,
      };
    },
    applyCatalogDrug(form, drug) {
      form.id_drug = drug.id_drug;
      form.drug_name = drug.drug_name;
      form.concentration = drug.concentration ?? '';
      form.pharmaceutical_form = drug.pharmaceutical_form ?? '';
      form.controlled = !!drug.controlled;
      form.regulatory_status = drug.regulatory_status ?? null;
      form.regulatory_type = drug.regulatory_type ?? null;
      form.regulatory_type_description = drug.regulatory_type_description ?? null;
    },
    // Concentração e forma continuam: no manipulado elas costumam valer, o que
    // deixa de valer é o vínculo com o item industrializado do catálogo.
    clearCatalogLink(form) {
      form.id_drug = null;
      form.controlled = false;
      form.regulatory_status = null;
      if (form.item_kind === 'compounded') {
        return;
      }
      form.regulatory_type = null;
      form.regulatory_type_description = null;
    },
    presentationSummary(prescDrug) {
      if (prescDrug.item_kind === 'compounded') {
        return [prescDrug.pharmaceutical_form, [prescDrug.quantity, prescDrug.measure].filter(Boolean).join(' ')]
            .filter(Boolean)
            .join(' · ');
      }
      return [prescDrug.concentration, prescDrug.pharmaceutical_form, prescDrug.quantity, prescDrug.treatment_time]
          .filter(Boolean)
          .join(' · ');
    },
    getPrescDrugs() {
      http.get(`/professionals/${this.medicalRecord.id_prof}/patients/${this.medicalRecord.id_patient}/medical-records/${this.prescription.id_medrec}/prescriptions/${this.prescription.id_presc}/drugs`).then((response) => {
        this.prescDrugs = response.data;
      });
    },
    submitFormStoreDrug() {
      this.formStoreDrug.id_presc = this.prescription.id_presc;
      const adicionado = {...this.formStoreDrug};

      http.post(`/professionals/${this.medicalRecord.id_prof}/patients/${this.medicalRecord.id_patient}/medical-records/${this.prescription.id_medrec}/prescriptions/${this.prescription.id_presc}/drugs`, this.formStoreDrug).then((response) => {
        this.formStoreDrug = this.emptyDrugForm();
        this.focarPrimeiroCampo();
        Alert.toastSuccess("Medicamento cadastrado com sucesso.");

        return this.settleRegulatoryType(adicionado, response.data);
      }).then(() => {
        this.getPrescDrugs();
        this.$emit('regulatory-changed');
      }).catch(e => {
        Alert.toastError(e.response?.data?.message ?? e.response?.data ?? 'Não foi possível adicionar o medicamento.');
      });
    },
    /**
     * Item fora do catálogo não tem substância, então a API não classifica e a
     * emissão trava. Em vez de perguntar, assume o tipo que o médico escolheu
     * na criação — e diz que assumiu, porque isso fica gravado em nome dele.
     *
     * Item do catálogo que contradiz o tipo escolhido só gera aviso: quem
     * decide o documento é a substância, não a escolha.
     */
    settleRegulatoryType(enviado, criado) {
      if (enviado.item_kind === 'compounded') {
        return Promise.resolve();
      }

      const tipoDoItem = enviado.regulatory_type ?? null;
      const escolhido = this.chosenRegulatoryType;

      if (enviado.id_drug && tipoDoItem && escolhido && tipoDoItem !== escolhido) {
        Alert.toastWarning(
            `"${enviado.drug_name}" exige ${this.regulatoryName(tipoDoItem)}, diferente de ${this.chosenTypeName}. ` +
            'Ele vai sair em um documento separado.');

        return Promise.resolve();
      }

      if (enviado.id_drug || !escolhido || !criado?.id_presc_drug) {
        return Promise.resolve();
      }

      return http.put(`/professionals/${this.medicalRecord.id_prof}/patients/${this.medicalRecord.id_patient}/medical-records/${this.prescription.id_medrec}/prescriptions/${this.prescription.id_presc}/drugs/${criado.id_presc_drug}/regulatory-type`, {
        regulatory_type: escolhido,
      }).then(() => {
        Alert.toastInfo(
            `"${enviado.drug_name}" não está no catálogo e entrou como ${this.regulatoryName(escolhido)}, ` +
            'o tipo desta prescrição.');
      }).catch(() => {
        // Sem o tipo o item fica pendente e a tela mostra o seletor manual.
      });
    },
    regulatoryName(code, fallback = '') {
      return this.regulatoryTypes.find((tipo) => tipo.code === code)?.name ?? (fallback || code);
    },
    abrirFormulario() {
      this.formAberto = true;
      this.focarPrimeiroCampo();
    },
    fecharFormulario() {
      this.formAberto = false;
      this.formStoreDrug = this.emptyDrugForm();
      this.formStoreDrugErrors = [];
    },
    focarPrimeiroCampo() {
      this.$nextTick(() => {
        this.$el.querySelector?.('.drug-form-inline input, .drug-form-inline textarea')?.focus();
      });
    },
    onClickBtnEditDrug(prescDrug) {
      this.formEditDrug.id_presc_drug = prescDrug.id_presc_drug;
      this.formEditDrug.id_presc = prescDrug.id_presc;
      this.formEditDrug.id_drug_admin = prescDrug.id_drug_admin;
      this.formEditDrug.item_kind = prescDrug.item_kind ?? 'medication';
      this.formEditDrug.drug_name = prescDrug.drug_name;
      this.formEditDrug.id_drug = prescDrug.id_drug ?? null;
      this.formEditDrug.measure = prescDrug.measure ?? '';
      this.formEditDrug.composition = prescDrug.composition ?? '';
      this.formEditDrug.regulatory_type = prescDrug.regulatory_type_manual ?? prescDrug.regulatory_type ?? 'SIMPLES';
      this.formEditDrug.concentration = prescDrug.concentration ?? '';
      this.formEditDrug.pharmaceutical_form = prescDrug.pharmaceutical_form ?? '';
      this.formEditDrug.quantity = prescDrug.quantity ?? '';
      this.formEditDrug.continuous_use = prescDrug.continuous_use ?? false;
      this.formEditDrug.dosage_desc = prescDrug.dosage_desc;
      this.formEditDrug.treatment_time = prescDrug.treatment_time ?? '';
      this.formEditDrug.monthly_quantity = prescDrug.monthly_quantity ?? '';
      this.formEditDrug.drug_obs = prescDrug.drug_obs ?? '';
    },
    deleteDrug(presDrugId) {
      Swal.fire({
        title: 'Heeyy',
        text: "Tem certeza que deseja remover o medicamento?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, remover!',
        cancelButtonText: 'Cancelar',
        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: 'btn btn-secundary'
        }
      }).then((result) => {
        if (result.isConfirmed) {
          http.delete(`/professionals/${this.medicalRecord.id_prof}/patients/${this.medicalRecord.id_patient}/medical-records/${this.prescription.id_medrec}/prescriptions/${this.prescription.id_presc}/drugs/${presDrugId}`).then(_ => {
            this.getPrescDrugs();
            this.$emit('regulatory-changed');
            Alert.toastSuccess("Medicamento excluÍdo com sucesso.");
          }).catch(e => {
            Alert.toastError(e.response.data);
          })
        }
      });
    },
    submitFormEditDrug() {
      this.formEditDrugErrors = [];
      http.put(`/professionals/${this.medicalRecord.id_prof}/patients/${this.medicalRecord.id_patient}/medical-records/${this.prescription.id_medrec}/prescriptions/${this.prescription.id_presc}/drugs/${this.formEditDrug.id_presc_drug}`, this.formEditDrug).then(() => {
        this.getPrescDrugs();
        this.$emit('regulatory-changed');
        Alert.toastSuccess("Medicamento atualizado com sucesso.");
        bootstrap.Modal.getInstance(document.getElementById('modal_edit_drug_' + this.prescription.id_presc)).toggle();
      }).catch(e => {
        Alert.toastError(e.response.data.message??e.response.data);
        if (e.response.data.errors) {
          this.formEditDrugErrors = e.response.data.errors;
        }
      });
    },
  },
}
</script>

<style scoped>


/* Formulario do medicamento. Com um campo por linha e mb-6/mt-4 em cada bloco,
   o modal passava de uma tela de altura e obrigava a rolar para chegar no
   Cadastrar. Em grade, os campos curtos dividem a linha e o form cabe inteiro. */
.drug-form {
  padding: 1.25rem 1.5rem;
}

.drug-form-inline {
  margin-top: 4px;
  padding: 16px 2px 2px;
  border-top: 1px solid #eef0f2;
}

.drug-form-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.drug-form-title {
  margin: 0 0 12px;
  font-size: 0.9rem;
  font-weight: 700;
  color: #4b5675;
}

.drug-form-close {
  border: 0;
  background: transparent;
  color: #a1a5b7;
  padding: 0 0 12px;
  line-height: 1;
}

.drug-form-close:hover {
  color: #4b5675;
}

.drug-add-trigger {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  margin-top: 8px;
  padding: 10px 14px;
  border: 1px solid #780f5a;
  border-radius: 8px;
  background: #fff;
  color: #780f5a;
  font-size: 0.9rem;
  font-weight: 600;
  text-align: left;
}

.drug-add-trigger:hover {
  color: #65104c;
  border-color: #65104c;
  background: #f8f5f7;
}

.drug-form-actions {
  margin-top: 16px;
}

.drug-form :deep(.form-label) {
  font-size: 0.85rem;
  font-weight: 600;
  color: #4b5675;
  margin-bottom: 0.35rem;
}

.drug-form :deep(.form-control),
.drug-form :deep(.form-select) {
  padding: 0.55rem 0.85rem;
  font-size: 0.95rem;
  min-height: auto;
}

.drug-form :deep(.form-check-label) {
  font-size: 0.85rem;
  color: #4b5675;
}

/* Uso contínuo anda junto da posologia: é uma propriedade dela, e sozinho
   numa linha gastava altura só com espaço em branco. */
.drug-form-label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 0.35rem;
}
.drug-list {
  border-top: 1px solid #eef0f2;
}

.drug-item-block + .drug-item-block {
  border-top: 1px solid #eef0f2;
}

.drug-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 2px;
}

.drug-group-head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 2px 4px;
  border-top: 1px solid #eef0f2;
}

.drug-list > .drug-group-head:first-child {
  border-top: 0;
  padding-top: 4px;
}

.drug-group-title {
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #4b5675;
}

.drug-group-count {
  font-size: 0.75rem;
  color: #a1a5b7;
}

.drug-item-change-type {
  border: 0;
  background: transparent;
  padding: 0;
  color: #780f5a;
  font-size: 0.75rem;
  text-decoration: underline;
}

.drug-item-change-type:hover {
  color: #65104c;
}

.drug-item-change {
  margin: 8px 0 4px 28px;
  padding: 10px 12px;
  background: #f8f5f7;
  border-radius: 8px;
}

.drug-item-change-label {
  display: block;
  margin-bottom: 6px;
  font-size: 0.8rem;
  font-weight: 600;
  color: #4b5675;
}

.drug-item-change-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}

.drug-item-change-actions select {
  flex: 1 1 220px;
  min-width: 0;
}

.drug-item-change-note {
  margin: 8px 0 0;
  font-size: 0.75rem;
  color: #7e8299;
}

.drug-item-index {
  flex-shrink: 0;
  width: 18px;
  padding-top: 2px;
  color: #6c757d;
  font-size: 0.8rem;
  font-weight: 600;
  line-height: 1.4;
  text-align: right;
}

.drug-item-body {
  flex: 1;
  min-width: 0;
}

.drug-item-top {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
}

.drug-item-identity {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 8px;
  min-width: 0;
  flex: 1 1 160px;
}

.drug-item-name {
  font-weight: 600;
  color: #212529;
  line-height: 1.35;
  overflow-wrap: break-word;
}

.drug-item-presentation {
  color: #6c757d;
  font-size: 0.8rem;
  line-height: 1.35;
  overflow-wrap: break-word;
}

.drug-item-aside {
  display: flex;
  align-items: center;
  gap: 6px;
  flex: 0 0 auto;
  margin-left: auto;
}

.drug-item-route {
  padding: 2px 8px;
  border-radius: 6px;
  background: #f1f3f5;
  color: #495057;
  font-size: 0.75rem;
  font-weight: 600;
  white-space: nowrap;
}

.drug-item-actions {
  display: flex;
  gap: 4px;
}

.drug-item-actions .btn {
  width: 32px;
  height: 32px;
}

.drug-item-dosage {
  margin-top: 3px;
  color: #495057;
  line-height: 1.4;
  overflow-wrap: break-word;
}

.drug-item-obs {
  margin-top: 2px;
  color: #6c757d;
  font-size: 0.85rem;
  line-height: 1.35;
  white-space: pre-wrap;
  overflow-wrap: break-word;
}

.drug-item-pending {
  padding: 0 12px 12px 40px;
}

.regulatory-summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-left: 3px solid #780f5a;
  border-radius: 8px;
  padding: 10px 16px;
  margin-top: 8px;
}

.regulatory-summary-blocked {
  background: #fff9db;
  border-left-color: #e0a800;
}

.regulatory-summary-text {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #495057;
  font-weight: 600;
}

</style>